import React from "react";
import avatar from "../assets/avatar-profile.jpg";

function Intro() {
    return (
        <div className="intro">
            <div className="intro-start">
                <h3 className="" >Hello, my name is</h3>
                <h1 className="intro-heading">Emma Kamau.</h1>
                <h1 className="intro-work">I build things for the web.</h1>
                <p className="intro-desc">
                    I'm a software developer based in Nairobi, Kenya.<br/> 
                    I specialize in building and occasionally designing <br/>
                    exceptional websites, applications, and everything in between.<br/>
                    Currently, I'm focused on building accessible, human-centered <br/>
                    products at 637 Capital.
                </p>
                <br/>
            </div>
            <div className="intro-end">
                <img src={avatar} alt="avatar" className="avatar-img" />
            </div>
        </div>
    );
}

export default Intro;